/**
 *
 * 模型剖切
 *
 * 功能点:方案演示
 * 场景:沙盘，方案
 * 版本 1.0
 *
 */
import Vue from "@/main";
import * as modelMap from "@/views/index/map.js";
/**
 * 剖切演示
 * @var cutArrPositions - 剖切对象的坐标数组 会返回给后台
 * @var graphicCutLayer - 当前地图上的剖切图层
 * @var distance - 距离 滚动的数值
 * @var distanceCounter - 距离 计数器 用于平移
 * @var direction - 起点指向终点的方向 用于切面平移
 * @var graphicCutType - 剖切的类型 有编辑和展示 区别在于有没有红色的分割线
 * @var cutList - 储存了当前场景的所有剖切数据
 */
// let cutArr = [];
export let cutArrPositions = "";
export let graphicCutType = "edit";
export let cutList = [];
let graphicCutLayer = [];
let distance = 0;
let distanceCounter = 0;
let direction = null;

/**
 * 功能类
 * 绘制线
 * @param  { Object } idArr - 模型id
 * @returns { void }
 *
 */
export function drawLine(idArr, fn = () => {}) {
  if (typeof idArr == "string") {
    idArr = [idArr];
  }
  if (idArr) {
    idArr.forEach((item) => {
      modelMap.modelAddRemove("add", item, () => {});
    });
  }
  initGraphicCutLayer();
  editGraphicCutType("edit");
  // Vue.$GLOBAL.map.graphicLayer 临时存储 使用完释放就行
  Vue.$GLOBAL.map.graphicLayer.startDraw({
    type: "polyline",
    maxPointNum: 2,
    style: {
      color: "#007be6",
      opacity: 0.8,
      outline: false,
    },
    success: function(graphic) {
      // 绘制成功后回调

      const positions = graphic.positionsShow;
      initGraphicLayer();
      console.log("绘制坐标为", mars3d.LngLatArray.toArray(positions));
      // 测试 不同角度 相同坐标点是否会相反
      // const positions = [
      //   Cesium.Cartesian3.fromDegrees(114.15828734, 22.56946271, -0.01),
      //   Cesium.Cartesian3.fromDegrees(114.16343257, 22.55855037, -0.01),
      // ];
      cutArrPositions = JSON.stringify(mars3d.LngLatArray.toArray(positions)); // 方便提交保存
      drawSection(positions, idArr);
      fn();
    },
  });
}

/**
 * 功能类
 * 绘制面
 * @param  { Object } idArr - 模型id
 * @returns { void }
 *
 */
export function drawPoly(idArr, fn = () => {}) {
  if (typeof idArr == "string") {
    idArr = [idArr];
  }
  if (idArr) {
    idArr.forEach((item) => {
      modelMap.modelAddRemove("add", item, () => {});
    });
  }
  initGraphicCutLayer();
  Vue.$GLOBAL.map.graphicLayer.startDraw({
    type: "polygon",
    style: {
      color: "#007be6",
      opacity: 0.5,
      clampToGround: true,
    },
    success: function(graphic) {
      // // 绘制成功后回调
      const positions = graphic.positionsShow;
      initGraphicLayer();
      console.log(
        "绘制坐标为",
        JSON.stringify(mars3d.LngLatArray.toArray(positions))
      ); // 方便测试拷贝坐标
      cutArrPositions = JSON.stringify(mars3d.LngLatArray.toArray(positions));
      editGraphicCutType("edit");
      drawSection(positions, idArr);
      fn();
    },
  });
}

/**
 * 功能类
 * 绘制 剖切 数据
 * @param  { Array } positions - 坐标数据
 * @param  { Array } idArr - 模型id
 * @returns { void }
 *
 */
export function drawSection(
  positions,
  idArr,
  id,
  normalz = 0,
  ifMapClone = false
) {
  let map;
  if (ifMapClone) {
    map = Vue.$GLOBAL.mapClone;
  } else {
    map = Vue.$GLOBAL.map;
  }
  let edgeWidth = graphicCutType === "edit" ? 3 : 0;
  if (graphicCutType === "edit" || graphicCutType === "demonstrate") {
    if (typeof idArr == "string") {
      idArr = [idArr];
    }
  }
  // 版本2 直接切除所有模型  idArr 改为当前场景下所有模型的id集合
  // console.log(map.getLayers());
  idArr = [];
  map.getLayers().forEach((item) => {
    console.log(item.options.modelTitle);
    if (item.options.modelTitle) {
      idArr.push(item.options.modelId);
    }
  });

  for (const item of idArr) {
    if (map.getLayer(item, "modelId")) {
      let cutLayer = new mars3d.thing.TilesetPlanClip({
        layer: map.getLayer(item, "modelId"),
        modelClipId: id || "add",
        modelId: item,
        positions: positions,
        edgeColor: Cesium.Color.RED,
        edgeWidth: edgeWidth,
        // showPlane: true, //测试
      });
      map.addThing(cutLayer);
      if (normalz) cutLayer.normalZ = normalz;
      const index = graphicCutLayer.findIndex(
        (obj) => obj.options.modelId === item
      );
      if (index !== -1) {
        graphicCutLayer.splice(index, 1, cutLayer);
      } else {
        graphicCutLayer.push(cutLayer);
      }
      let { center } = map.getLayer(item, "modelId");
      if (center) {
        const lng = center._lng;
        const lat = center._lat;
        const alt = center._alt;
        direction = null;
        direction = Cesium.Cartesian3.subtract(
          Cesium.Cartesian3.fromDegrees(lng, lat, alt),
          positions[0],
          new Cesium.Cartesian3()
        );
      }
    } else if (graphicCutType !== "demonstrate") {
      let list = {};
      if (!ifMapClone) {
        list = { mapType: "clone" };
      }
      modelMap.modelAddRemove("add", item, (i, e) => {
        let cutLayer = new mars3d.thing.TilesetPlanClip({
          layer: e.layer,
          modelClipId: id || "add",
          modelId: item,
          positions: positions,
          edgeColor: Cesium.Color.RED,
          edgeWidth: edgeWidth,
          // showPlane: true, //测试
        });
        map.addThing(cutLayer);
        if (normalz) cutLayer.normalZ = normalz;
        const index = graphicCutLayer.findIndex(
          (obj) => obj.options.modelId === item
        );
        console.log(index !== -1 && graphicCutType !== "edit");
        if (
          index !== -1 &&
          (graphicCutType !== "edit" || graphicCutType !== "demonstrate")
        ) {
          graphicCutLayer.splice(index, 1, cutLayer);
        } else {
          graphicCutLayer.push(cutLayer);
        }
        let { center } = e.layer;
        if (center) {
          const lng = center._lng;
          const lat = center._lat;
          const alt = center._alt;
          direction = null;
          direction = Cesium.Cartesian3.subtract(
            Cesium.Cartesian3.fromDegrees(lng, lat, alt),
            positions[0],
            new Cesium.Cartesian3()
          );
        }
      });
    }
  }
  // console.log("zhangguan", graphicCutType, graphicCutLayer);
}

/**
 * 工具类
 * 组装数据调研 drawSection 展示剖切
 * @param  { String } positions - 坐标数据
 * @param  { String } idArr - 模型id
 * @returns { void }
 *Cesium.Cartesian3.fromDegrees(114.05031057,22.59562036,0);
 */
export function assemblyData(
  positions,
  idArr,
  id,
  normalz = 0,
  ifMapClone = false
) {
  console.log(graphicCutType);
  let newPositions = [],
    newIdArr;
  if (IsJsonString(idArr)) {
    newIdArr = JSON.parse(idArr);
  } else {
    newIdArr = [idArr];
  }
  JSON.parse(positions).forEach((i) => {
    newPositions.push(Cesium.Cartesian3.fromDegrees(i[0], i[1], i[2]));
  });

  if (
    IsModel(newIdArr, id) ||
    graphicCutType === "edit" ||
    graphicCutType === "demonstrate"
  )
    drawSection(newPositions, newIdArr, id, normalz, ifMapClone);
}

/**
 * 工具类
 * 初始化 裁剪数据
 * @returns { void }
 *
 */
export function initGraphicCutLayer() {
  if (graphicCutLayer.length > 0) {
    graphicCutLayer.forEach((e) => {
      e.clear();
    });
    graphicCutLayer = [];
  }
}

/**
 * 工具类
 * 初始化 线面 数据
 * @returns { void }
 *
 */
export function initGraphicLayer() {
  if (Vue.$GLOBAL.map.graphicLayer) {
    Vue.$GLOBAL.map.graphicLayer?.clear();
  }
}

/**
 * 功能类
 * 让裁剪面向模型中心点移动
 * @param  { Number } val - 滚动轴参数
 * @param  { Number } normalz - 滚动轴参数
 *
 */
export function renewDistance(val, normalz = 0) {
  distanceCounter = val - distance;
  distance = val;
  graphicCutLayer?.forEach((e) => {
    // 更新坐标点
    let renewPosition = [];
    e.positions?.forEach((p) => {
      renewPosition.push(translateByDirection(p, direction, distanceCounter));
    });
    e.positions = renewPosition;
    e.normalZ = normalz;
  });
  cutArrPositions =
    graphicCutLayer.length > 0 ? graphicCutLayer[0].positions : cutArrPositions;
  return JSON.stringify(mars3d.LngLatArray.toArray(cutArrPositions));
}

/**
 * 功能类
 * 让裁剪面向模型中心点移动
 * @param  { Object } val - 滚动轴参数
 * 白膜中心点测试
 * var cartesian3 = Cesium.Cartesian3.fromDegrees(114.05031057,22.59562036,0);
 *
 */
export function renewNormalz(val) {
  graphicCutLayer.forEach((e) => {
    e.normalZ = val;
  });
}

/**
 * 工具类
 * @description: 根据一个原点，向一个方向上平移多少米后，求得另一个点的坐标
 * @param { Cartesian3 } start - 原点
 * @param { Cartesian3 } direction - 起点指向终点的方向
 * @param { Number } offset - 平移距离，单位米
 * @returns { Cartesian3 } - 目标点
 *
 */

function translateByDirection(start, direction, offset) {
  let normalize = Cesium.Cartesian3.normalize(
    direction,
    new Cesium.Cartesian3()
  ); //根据偏移量求偏移向量

  let scalerNormalize = Cesium.Cartesian3.multiplyByScalar(
    normalize,
    offset,
    new Cesium.Cartesian3()
  );

  return Cesium.Cartesian3.add(start, scalerNormalize, new Cesium.Cartesian3());
}

/**
 * 功能类
 * 初始化
 * @returns { void }
 */
export function init(val) {
  // initGraphicLayer();
  initGraphicCutLayer();
  editGraphicCutType("");
  graphicCutLayer = [];
}

/**
 *
 * 功能类
 * 修改 graphicCutType 值
 * @returns { void }
 */
export function editGraphicCutType(type) {
  graphicCutType = type;
}

/**
 * 工具类
 * 判断是不是Json字符串
 * @returns { void }
 */
export function IsJsonString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

/**
 * 工具类
 * 验证模型是否加载
 * @returns { void }
 */
export function IsModel(idArr, id) {
  const modelNotDisplayed = idArr.some((item) => {
    if (Vue.$GLOBAL.map.getLayer(item, "modelId") == undefined) {
      console.log(graphicCutType);
      if (graphicCutType !== "edit" && graphicCutType !== "demonstrate")
        Vue.$message({
          message: "请先展示需要操作的模型",
          type: "warning",
          duration: 2000,
        });
      return true; // 如果找到未展示的模型，则返回true
    }
  });

  if (modelNotDisplayed) {
    return false;
  }

  const objToRemove = graphicCutLayer.find((obj) => {
    let { modelId, modelClipId } = obj.options;
    return modelClipId == id && idArr.indexOf(modelId) > -1;
  });

  if (objToRemove) {
    objToRemove.clear();
    graphicCutLayer = graphicCutLayer.filter((obj) => obj !== objToRemove);
    return false;
  }
  return true;
}

export function demonstrate(value, id, fn, ...list) {
  console.log("开始", value, id, fn, ...list, cutList);
  if (value) {
    let ifMapClone = false;
    if (list.length > 0 && list[0] != undefined) {
      let { mapType } = list[0];
      if (mapType == "clone") {
        ifMapClone = true;
      }
    }
    let cutData;
    cutData = cutList.find((e) => e.id == id);
    editGraphicCutType("demonstrate");
    let { cutPosition, cutModel, normalz } = cutData;
    assemblyData(cutPosition, cutModel, id, normalz, ifMapClone);
  } else {
    init();
  }
}

/**
 * 工具类
 * 更新cutList
 * @returns { void }
 */
export function getCutList(obj) {
  cutList = obj;
}
